import * as React from "react";

export interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const searchInputStyle: React.CSSProperties = {
  width: "100%",
  padding: "8px 12px",
  border: "1px solid #e0e0e0",
  borderRadius: "4px",
  fontSize: "13px",
  outline: "none",
  transition: "border-color 0.2s",
};

const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder = "Search categories...",
}) => (
  <div style={{ marginBottom: "12px" }}>
    <input
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={searchInputStyle}
      onFocus={(e) => {
        e.target.style.borderColor = "#0066cc";
      }}
      onBlur={(e) => {
        e.target.style.borderColor = "#e0e0e0";
      }}
    />
  </div>
);

export default SearchInput;
